import React, { Component } from 'react';
import QualificationItemComponent from './qualification.item.component'
class QualificationComponent extends Component {
    render() {
        const items = this.props.items;
        let index = 0;
        const itemsTag = items.map(item =>
            <QualificationItemComponent key={index++} date={item.date} name={item.name} issuer={item.issuer} place={item.place} />
        )
        return (
            <div>
                <h2>{this.props.title}</h2>
                <ul className="qualifications">
                    {itemsTag}
                </ul>
            </div>
        );
    }
}

export default QualificationComponent;



// WEBPACK FOOTER //
// ./src/components/qualification/qualification.component.jsx